import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.for-each.js";
export default {
  name: "im-chat-record",
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        userId: this.$route.query.userId,
        otherId: this.$route.query.otherId
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      userData: {},
      //用户信息
      initiator: {
        userId: "",
        otherId: ""
      },
      total: 0
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getUserInfo();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    textMessageFormat: function textMessageFormat(text) {
      var emojiKeys = ['TUIEmoji_Smile', 'TUIEmoji_Expect', 'TUIEmoji_Blink', 'TUIEmoji_Guffaw', 'TUIEmoji_KindSmile', 'TUIEmoji_Haha', 'TUIEmoji_Cheerful', 'TUIEmoji_Speechless', 'TUIEmoji_Amazed', 'TUIEmoji_Sorrow', 'TUIEmoji_Complacent', 'TUIEmoji_Silly', 'TUIEmoji_Lustful', 'TUIEmoji_Giggle', 'TUIEmoji_Kiss', 'TUIEmoji_Wail', 'TUIEmoji_TearsLaugh', 'TUIEmoji_Trapped', 'TUIEmoji_Mask', 'TUIEmoji_Fear', 'TUIEmoji_BareTeeth', 'TUIEmoji_FlareUp', 'TUIEmoji_Yawn', 'TUIEmoji_Tact', 'TUIEmoji_Stareyes', 'TUIEmoji_ShutUp', 'TUIEmoji_Sigh', 'TUIEmoji_Hehe', 'TUIEmoji_Silent', 'TUIEmoji_Surprised', 'TUIEmoji_Askance', 'TUIEmoji_Ok', 'TUIEmoji_Shit', 'TUIEmoji_Monster', 'TUIEmoji_Daemon', 'TUIEmoji_Rage', 'TUIEmoji_Fool', 'TUIEmoji_Pig', 'TUIEmoji_Cow', 'TUIEmoji_Ai', 'TUIEmoji_Skull', 'TUIEmoji_Bombs', 'TUIEmoji_Coffee', 'TUIEmoji_Cake', 'TUIEmoji_Beer', 'TUIEmoji_Flower', 'TUIEmoji_Watermelon', 'TUIEmoji_Rich', 'TUIEmoji_Heart', 'TUIEmoji_Moon', 'TUIEmoji_Sun', 'TUIEmoji_Star', 'TUIEmoji_RedPacket', 'TUIEmoji_Celebrate', 'TUIEmoji_Bless', 'TUIEmoji_Fortune', 'TUIEmoji_Convinced', 'TUIEmoji_Prohibit', 'TUIEmoji_666', 'TUIEmoji_857', 'TUIEmoji_Knife', 'TUIEmoji_Like'];
      var emojiPattern = /\[TUIEmoji_([^\]]+)\]/g;
      text = text.replace(emojiPattern, function (match, key) {
        console.log(match, key);
        var emojiKey = "TUIEmoji_".concat(key);
        var index = emojiKeys.indexOf(emojiKey);
        if (index > -1) {
          return "<img src=\"https://qnimg1.wellcee.com/emoji/emoji_".concat(index, ".png\" alt=\"").concat(key, "\" style=\"width:30px;display: inline-block;vertical-align: middle;\">");
        } else {
          return match;
        }
      });
      return text;
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getUserInfo: function getUserInfo() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var userIds;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              userIds = [_this2.searchForm.userId, _this2.searchForm.otherId];
              _this2.$api.getUserListByIds({
                userIds: userIds
              }).then(function (res) {
                _this2.userData = res.data;
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getData: function getData() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.tableLoading = true;
              _context3.n = 1;
              return _this3.$api.getChatRecord(_this3.searchForm);
            case 1:
              res = _context3.v;
              res.data.list.forEach(function (item) {
                if (item.objectName === 'system' && item.msg.indexOf('qnimg1.wellcee') > -1 && item.msg.indexOf('MsgType') == -1) {
                  item.objectName = 'RC:ImgMsg';
                }
                if (item.objectName === 'system' && item.msg && item.msg.indexOf('MsgType') > -1) {
                  item.msg = JSON.parse(item.msg);
                }
                if (item.objectName === 'RC:HQVCMsg' && typeof item.msg === 'string' && item.msg.startsWith('{')) {
                  try {
                    item.msg = JSON.parse(item.msg);
                  } catch (e) {
                    console.log(e);
                  }
                }
              });
              _this3.tableData = res.data.list;
              _this3.total = res.data.count;
              _this3.initiator.userId = res.data.initiatorId;
              _this3.initiator.otherId = res.data.initiatedId;
              _this3.tableLoading = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  }
};